import {
  type NewsletterAgreementValues,
  newsletterAgreementValues,
  type PhoneContactAgreementValues,
  phoneContactAgreementValues,
} from "apps/visits/packages/shared/modules/synerise/forms/shared";
import type { SnakeCase } from "type-fest";
import * as yup from "yup";
import { formTypeFactory } from "../synerise";

type InferredRegistrationFormSchema = yup.InferType<typeof registrationFormSchema>;
type RegistrationFormData = Omit<InferredRegistrationFormSchema, "city" | "phoneContactAgreement" | "isB2b"> & {
  city?: InferredRegistrationFormSchema["city"];
  phoneContactAgreement?: InferredRegistrationFormSchema["phoneContactAgreement"]; // TODO: Delete it after fixing Visits Registration Form - https://house-med.atlassian.net/browse/UP-4887
  isB2b?: InferredRegistrationFormSchema["isB2b"];
};

const registrationFormSchema = yup.object({
  email: yup.string().email().required(),
  phone: yup.string().required(),
  firstname: yup.string().min(3).required(),
  lastname: yup.string().min(3).required(),
  newsletterAgreement: yup
    .mixed<NewsletterAgreementValues>()
    .oneOf([...newsletterAgreementValues])
    .required(),
  phoneContactAgreement: yup
    .mixed<PhoneContactAgreementValues>()
    .oneOf([...phoneContactAgreementValues])
    .optional(), // TODO: Change it to required after fixing Visits Registration Form - https://house-med.atlassian.net/browse/UP-4887
  city: yup.string().optional(),
  isB2b: yup.boolean().optional(),
});

/*
 * Tricky solution for set attribute [`city`, `phoneContactAgreement`, `isB2b`] not required
 * */
const registrationFormSchemaWithoutOptionalFields = registrationFormSchema.omit([
  "city",
  "phoneContactAgreement",
  "isB2b",
]);

export const registrationFormFactory = <Type extends string>(formType: SnakeCase<Type>, data: RegistrationFormData) =>
  formTypeFactory<Type, typeof registrationFormSchemaWithoutOptionalFields>(formType, registrationFormSchema)(data);
